import { DropdownSchemeDefinition } from "./dropdown-types";
import { BackgroundColor } from "../../background/constants/background-types";

import * as AllColors from "../../../constants/colors";
import { toConstantCase } from "../../../utils/string-format";
import { createDropdownMapDefinition } from "../../../utils/scheme-helper";

export const DROPDOWN_SIZE_SMALL = "small";
export const DROPDOWN_SIZE_NORMAL = "normal";

export const DROPDOWN_SIZES = [DROPDOWN_SIZE_SMALL, DROPDOWN_SIZE_NORMAL] as const;

function createSchemes() {
  let newSchemes: AllColors.DropdownSchemeConfiguration<DropdownSchemeDefinition> = {};

  AllColors.DROPDOWN_SCHEMES.forEach((element) => {
    newSchemes[element.schemeName] = {
      borderColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_TINT_1`],
      borderHoverColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_SHADE_1`],
      borderActiveColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}`],
      labelColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      errorMessageColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_SHADE_2`],
      trailingIconBackgroundColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_SHADE_2`],
      trailingIconColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_TINT_2`],
      trailingIconColorHover: AllColors[`COLOR_${toConstantCase(element.schemeName)}_SHADE_1`],
      trailingIconColorActive: AllColors[`COLOR_${toConstantCase(element.schemeName)}_SHADE_1`],
      disabledBackgroundColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_SHADE_1`],
      disabledBorderColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_SHADE_1`],
      disabledTrailingIconColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_SHADE_1`],
      disabledLabelColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      disabledOpacity: 0.6,
      optionsBackgroundColor: AllColors.COLOR_BRIGHT,
      multiselectDeleteBackgroundColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_SHADE_1`],
      multiselectDeleteFontColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      multiselectDeleteIconColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_FONT`],
      multiselectDeleteIconHoverColor: AllColors[`COLOR_${toConstantCase(element.schemeName)}_SHADE_1`]
    };
    if (element.scheme) {
      newSchemes[element.schemeName] = { ...newSchemes[element.schemeName], ...element.scheme };
    }
  });
  return newSchemes;
}

export const DROPDOWN_SCHEME_CONFIG: AllColors.DropdownSchemeConfiguration<DropdownSchemeDefinition> = createSchemes();

export const DROPDOWN_SCHEME_MAP: Map<BackgroundColor | "default", DropdownSchemeDefinition> = new Map(
  Object.entries(createDropdownMapDefinition()).map(([background, config]) => [
    background as BackgroundColor,
    DROPDOWN_SCHEME_CONFIG[config as string]
  ])
);
